import Nonli from './nonli'

const nonli = new Nonli()
nonli.init()
